import { API_CENTRAL_URL } from "configs/AppConfig";
import { useState, useEffect } from "react";
import { LANGUAGE, translate } from "services/general";
import { Modal, Spin } from "antd";
import { useTranslation } from "react-i18next";

const CustomPage = ({ open, onClose, slug }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  useEffect(() => {
    if (open && slug) {
      const loadData = async () => {
        try {
          setLoading(true);
          const response = await fetch(
            `${API_CENTRAL_URL}/${LANGUAGE}/pages/${slug}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          const result = await response.json();
          if (response.ok) {
            setData(result.data);
          } else {
            setData(null);
          }
        } catch (error) {
          console.error("Error fetching custom page:", error);
        } finally {
          setLoading(false);
        }
      };
      loadData();
    } else {
      setLoading(false);
    }
  }, [open, slug]);
  // Format date based on language
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      const locale = LANGUAGE === "ar" ? "ar-SA" : "en";
      return date.toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return "";
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={null}
      closable={false}
      width="100%"
      className="rounded-2xl text-white pages"
      styles={{
        content: {
          maxWidth: "636px",
          margin: "16px auto",
        },
      }}
      style={{
        maxWidth: "636px",
      }}
    >
      {loading ? (
        <div className="flex flex-col items-center justify-center py-12 md:py-20">
          <Spin size="large" />
          <p className="text-white mt-4 text-sm opacity-70">
            {LANGUAGE === "ar" ? "جاري التحميل..." : "Loading..."}
          </p>
        </div>
      ) : (
        <div>
          <div className="self-stretch inline-flex justify-between items-center w-full px-4 sm:px-6 md:px-9 gap-3 md:gap-4">
            <div className="flex items-center flex-1 min-w-0">
              <div className="justify-start text-Background text-lg sm:text-xl md:text-2xl font-bold leading-6 sm:leading-8 md:leading-10 truncate">
                {translate(data?.title, data?.en_title)}
              </div>
            </div>
            <img
              src={"/icons/close-line.svg"}
              alt={translate(data?.title, data?.en_title)}
              className="cursor-pointer flex-shrink-0 w-5 h-5 sm:w-6 sm:h-6"
              onClick={onClose}
            />
          </div>
          {data?.updated_at && (
            <div className="opacity-70 justify-start text-Background text-xs font-semibold tracking-tight px-4 sm:px-6 md:px-9 mt-2 md:mt-0">
              {t("custom_pages.lastUpdate")}: {formatDate(data.updated_at)}
            </div>
          )}
          <div className="w-full h-0 opacity-20 border border-1 border-white mt-4 sm:mt-6 md:mt-[23.5px] mb-3 md:mb-4"></div>
          <div className="px-4 sm:px-6 md:px-9 terms-content">
            <div
              className="prose prose-sm sm:prose-base max-w-none"
              dangerouslySetInnerHTML={{
                __html: translate(data?.description, data?.en_description),
              }}
            />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CustomPage;
